import {initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const recommendationProductSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {data}}) => {
            state.products = data.confirmedProductOrders.map((product) => {
                return {
                    ecNvMid: product.ecNvMid ?? undefined,
                    orderDateTime: product.orderDateTime ?? undefined,
                    productOrderStatus: product.productOrderStatus ?? undefined,
                    productPaymentAmount: product.productPaymentAmount ?? undefined,
                    productCategoryId: product.productCategoryId ?? undefined,
                }
            })
        })
    },
})

export default recommendationProductSlice.reducer
